/**
 * TÄLU · cards-3d
 *
 * Aplica mouse-tilt 3D + IntersectionObserver reveal stagger a cualquier card
 * marcado con `data-card-3d` (o cualquiera de los selectores configurables).
 *
 * Uso:
 *  <div class="uso-card" data-card-3d>...</div>
 *  <script src="../scripts/cards-3d.js" defer></script>
 *
 * Por defecto detecta:
 *  - .uso-card (sección "12 usos" en RAW)
 *  - cualquier elemento con [data-card-3d]
 */
(function () {
  'use strict';

  const SELECTORS = ['.uso-card', '.rec-card', '[data-card-3d]'];

  function bind(){
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Solo procesamos cards que NO han sido bound antes (idempotente)
    const cards = Array.from(document.querySelectorAll(SELECTORS.join(', ')))
      .filter(c => !c.dataset.cards3dBound);
    if (cards.length === 0) return;
    cards.forEach(c => { c.dataset.cards3dBound = '1'; });

    // Reveal stagger
    cards.forEach(c => c.classList.add('is-revealing'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting){
          const all = Array.from(document.querySelectorAll(SELECTORS.join(', ')));
          const idx = all.indexOf(e.target);
          const delay = reduceMotion ? 0 : Math.min(idx * 60, 700);
          setTimeout(() => {
            e.target.classList.remove('is-revealing');
            e.target.classList.add('is-revealed');
          }, delay);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    cards.forEach(c => io.observe(c));

    if (reduceMotion) return;

    // Mouse-tilt: --mx, --my CSS vars
    cards.forEach((card) => {
      let raf = null;
      const onMove = (ev) => {
        const r = card.getBoundingClientRect();
        const x = (ev.clientX - r.left) / r.width;
        const y = (ev.clientY - r.top) / r.height;
        const mx = (x - 0.5) * 2;
        const my = (y - 0.5) * 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          card.style.setProperty('--mx', mx.toFixed(3));
          card.style.setProperty('--my', my.toFixed(3));
        });
      };
      const onLeave = () => {
        if (raf) cancelAnimationFrame(raf);
        card.style.setProperty('--mx', '0');
        card.style.setProperty('--my', '0');
      };
      card.addEventListener('mousemove', onMove);
      card.addEventListener('mouseleave', onLeave);
    });
  }

  // Bind inicial + retry tras 200ms (por si components.js inyectó cards después)
  function init(){
    bind();
    setTimeout(bind, 200);
    setTimeout(bind, 600);  // doble retry para casos con scripts async
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // También al window load (cuando todos los assets cargaron)
  window.addEventListener('load', bind);
})();
